import type { GlobalContextReducerState } from '$training-portal/context/global-context/reducers/types';
import { GlobalContext } from '$training-portal/context/global-context';
import { useContext, useMemo } from 'react';

const useGlobalContext = () => useContext(GlobalContext);

// selector for database entity
export const useGlobalContextSelector: <T>(
  selector: (state: GlobalContextReducerState) => T
) => T = (selector) => {
  const context = useGlobalContext();

  if (!context) {
    throw new Error('useSelector must be used within a StateProvider');
  }

  const { state } = context;

  // Memoize the selected value
  return useMemo(() => selector(state), [selector, state]);
};

export default useGlobalContext;
